export const SEND_EMAIL = "SEND_EMAIL"
export const SEND_EMAIL_SUCCESSFUL = "SEND_EMAIL_SUCCESSFUL"
export const SEND_EMAIL_FAILED = "SEND_EMAIL_FAILED"
